import { Injectable } from '@angular/core';
import { AbstractDataServiceDtoSummaryAdapter } from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import { MedicalToolSetDataService } from './medicalToolSet.dataservice';
import { MedicalToolSetSummaryModel } from '../../../api/entity/medicalToolSetSummary.model';
import { MedicalToolSetSummaryConverter } from '../../../api/entity/converter/medicalToolSetSummary.converter';
import { MedicalToolSetModel } from '../../../api/entity/medicalToolSet.model';

@Injectable({
    providedIn: 'root'
})
export class MedicalToolSetSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<MedicalToolSetSummaryModel, MedicalToolSetSummaryConverter, MedicalToolSetModel> {
    constructor(dataService: MedicalToolSetDataService, converter: MedicalToolSetSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): MedicalToolSetModel {
        return new MedicalToolSetModel();
    }
}

